import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: false };

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps: Props) {
    if (this.state.error && this.props.children !== nextProps.children) {
      this.setState({ error: false });
    }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, info);
    this.setState({ error: true });
  }

  render() {
    if (this.state.error) return <h1>Something went wrong. Check the console.</h1>;
    return this.props.children;
  }
}
